import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import item1 from '../../img/inexCarousel/1.jpg';
import item2 from '../../img/inexCarousel/2.jpg';
import item3 from '../../img/inexCarousel/3.jpg';
import item4 from '../../img/inexCarousel/4.jpg';
import item5 from '../../img/inexCarousel/5.jpg';
import item6 from '../../img/inexCarousel/6.jpg';
import item7 from '../../img/inexCarousel/7.jpg';
import item8 from '../../img/inexCarousel/8.jpg';
import item9 from '../../img/inexCarousel/9.jpg';
import './WizzardBlock.scss';
import useWindowSize from "../../utils/resizeHook";

const imageArray = [
  item1,
  item2,
  item3,
  item4,
  item5,
  item6,
  item7,
  item8,
  item9
];

const CustomDot = ({ onClick, active }) => {
  return <div className={`wizzard-inex__dot ${active ? 'wizzard-inex__dot--active' : ''}`} onClick={() => onClick()}></div>;
};

const WizzardBlockInex = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const { currentWidth } = useWindowSize();

  return (
    <div className={`wizzard-inex ${currentWidth <= 700 && 'wizzard-inex__tablet'} ${currentWidth <= 550 && 'wizzard-inex__tablet-small'} ${currentWidth <= 450 && 'wizzard-inex__tablet-small-mobile'}`}>
      <Carousel
        showDots={true}
        responsive={responsive}
        removeArrowOnDeviceType={['tablet', 'mobile', 'desktop']}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        transitionDuration={500}
        customDot={<CustomDot />}
        renderDotsOutside={true}
      >
        {imageArray.map((item, index) => (
          <div className={`wizzard-inex__card ${currentWidth <= 700 && 'wizzard-inex__card__tablet'} ${currentWidth <= 550 && 'wizzard-inex__card__tablet-small'} ${currentWidth <= 450 && 'wizzard-inex__card__tablet-small-mobile'} wizzard-inex__card-${index}`} style={{ width: '100%' }}>
          </div>
        ))}
      </Carousel>
    </div>
  )
};

export default WizzardBlockInex;